import { TypedForm } from '@bo-client/shared/forms/generic-forms/typedForm.type';

export class ProducerModel {
  id: string;
  manufacturer: string;
  deviceTypeName: string;
  count: number; // units
  acActivePowerMax: number;
  acApparentPowerMax: number;
  phases: number;
  connectedPhases: number;
  maStRNumber?: string;
  zerezId?: string;
}

export type ProducerForm = TypedForm<ProducerModel>;
